import React from 'react';
import email_img from '../../assests/images/Iconzocial-email.png';
import lock_img from '../../assests/images/Iconawesome-lock.png';
import { Checkbox } from '@mui/material';
import { red } from '@mui/material/colors';
import { useNavigate } from 'react-router-dom';


const Signin = (props) => {

    const navigate = useNavigate();
    const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

    return (
        <div>
            <div className='py-5 px-4 signin-page'>
                <div className='row'>
                    <div className='col-lg-12 text-center'>
                        <p className='f-25 mb-4 f-pop-med'>Sign in</p>
                    </div>
                </div>

                <input type='text' placeholder='Email Address' className='form-control p-3 mb-2 f-14' />
                <div className='row'>
                    <div className='col-lg-12 text-end'>
                        <img className='ico_mail_hdr' src={email_img} alt="email_ico" />
                    </div>
                </div>
                <input type='password' placeholder='Password' className='form-control p-3 mb-2 f-14' />
                <div className='row'>
                    <div className='col-lg-12 text-end'>
                        <img className='ico_mail_hdr' src={lock_img} alt="lock_ico" />
                    </div>
                </div>
                <div className='row pos-rel top20pxneg'>
                    <div className='col-lg-6 p-0'>
                        <Checkbox
                            {...label}
                            defaultChecked
                            sx={{
                                color: red[800],
                                '&.Mui-checked': {
                                    color: red[800],
                                },
                            }}
                        />
                        <label className='f-13 f-pop-med'>Remember me</label>
                    </div>
                    <div className='col-lg-6 text-end align-self-center'>
                        <p onClick={() => { props.handleClickOpen(3) }} className='f-13 cursor_pointr text-danger f-pop-med'>Forgot Password</p>
                    </div>
                </div>
                <button onClick={() => { props.handleClickOpen(6) }} className='form-control p-3 border-0 bg-grad-login-header f-16 text-white f-pop-med'>Login</button>
                <div className='row mt-4'>
                    <div className='col-lg-12 text-center'>
                        <p className='f-13 f-pop-med'>Don't have an Account ?  <span className='text-danger cursor_pointr f-pop-med' onClick={() => { props.handleClickOpen(2) }}>SIGN UP</span> </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Signin;